/* eslint-disable sonarjs/no-duplicate-string */
import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const CustomerShape = z.any();

const FiltersShape = z.object({
  searchQuery: z.string().optional(),
  declarantId: z.string().optional(),
  brokerId: z.string().optional().nullable(),
  externalId: z.string().optional(),
  valid: z.boolean().optional(),
  sorting: z
    .object({
      sortField: z.string(),
      sortDirection: z.enum(['asc', 'desc']),
    })
    .optional(),
});

export const customerContract = c.router({
  listCustomers: {
    method: 'GET',
    path: '/customers/list',
    responses: {
      200: z.object({ data: z.array(CustomerShape) }),
    },
  },
  retrieveExternalRestrictedUsers: {
    method: 'GET',
    path: '/customers/retrieve-external-restricted-users',
    query: z.object({
      fullName: z.string(),
    }),
    responses: {
      200: z.object({ users: z.array(z.any()) }),
    },
  },
  createCustomer: {
    method: 'POST',
    path: '/customers/add',
    body: CustomerShape,
    responses: {
      200: z.object({ data: CustomerShape }),
    },
  },
  retrieveCustomers: {
    method: 'POST',
    path: '/customers',
    body: z.object({
      filters: FiltersShape.optional(),
      page: z.number().optional(),
      pageSize: z.number().optional(),
    }),
    responses: {
      200: z.object({
        data: z.object({
          list: z.array(CustomerShape),
          totalCustomers: z.number(),
        }),
      }),
    },
  },
  getCustomer: {
    method: 'GET',
    path: '/customers/:id',
    pathParams: z.object({ id: z.string() }),
    responses: {
      200: z.object({ data: CustomerShape }),
    },
  },
  updateCustomer: {
    method: 'PATCH',
    path: '/customers/:id',
    pathParams: z.object({ id: z.string() }),
    body: CustomerShape,
    responses: {
      200: z.object({ data: CustomerShape }),
    },
  },
  deleteCustomer: {
    method: 'DELETE',
    path: '/customers/:id',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  sendTransitGuaranteeAccessCode: {
    method: 'POST',
    path: '/customers/:id/transit-guarantees/:grn/send-access-code',
    pathParams: z.object({ id: z.string(), grn: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string() }),
      404: z.object({ message: z.string() }),
    },
  },
  sendTransitGuaranteeRequest: {
    method: 'POST',
    path: '/customers/:id/send-transit-guarantees-request',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string() }),
      404: z.object({ message: z.string() }),
    },
  },
});
